import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import * as yup from 'yup';
import { useState } from 'react';

import { ALL_SUBMIT_FORM } from 'app/helpers/apiEndpoint';
import { getTrackingData } from 'app/webtrack/tracking';
import { timeZoneCityToCountry } from 'app/helpers/timeZoneCityToCountry';
import REQUEST from 'app/helpers/http.service';
import { getUserLocationData, getLocaleIP } from 'app/scripts/utils';
const style = {
  inputField: {
    backgroundColor: '#F9F9F9',
    border: '0.5px solid rgba(146, 146, 146, 0.5)',
    borderRadius: '4px',
    padding: '8px 16px',
    height: '55px',
  },
};
export default function SubscribeMail({ isContect }) {
  const { asPath } = useRouter();
  const router = useRouter();
  const toast = useSelector(state => state?.toast);

  const [email2, setEmail2] = useState(true);
  const [active, setActive] = useState(false);
  const [locationip, setLocationIP] = useState(false);

  const locationData = getUserLocationData(timeZoneCityToCountry);

  const fetchIP = async () => {
    const { ip } = await getLocaleIP();
    setLocationIP(ip);
  };

  fetchIP();

  // .matches(
  //   /^(?!.*@(?:gmail|outlook|yahoo|protonmail|zoho|aol)\.\w{2,}$)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  //   'Work email addresses are allowed'
  // ),
  const Schema2 = yup.object().shape({
    email: yup
      .string()
      .email('Invalid email address')
      .required('Email is required'),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    resolver: yupResolver(Schema2),
    defaultValues: {
      email: '',
      countryName: locationData.userCountry,
      purpose: 'SUBSCRIBE',
      ctaText: 'SUBSCRIBE',
      pageUrl: asPath,
      leadSource: 'Subscribe to Newsletter',
    },
  });
  // SUBSCRIBE
  const isValidEmail2 = email2 =>
    setEmail2(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        email2
      )
    );

  const Submit = async data => {
    const trackingData = getTrackingData();

    // Ensure WebPagesVisited is a proper string
    const cleanedTrackingData = {
      ...trackingData,
      WebPagesVisited: Array.isArray(trackingData?.WebPagesVisited)
        ? trackingData.WebPagesVisited.join(', ') // Convert array to comma-separated string
        : trackingData?.WebPagesVisited || '', // Ensure it's a string
    };
    const formData = {
      ...data,
      ipAddress: locationip,
      trackingData: cleanedTrackingData, // Use cleaned tracking data
    };

    try {
      setActive(!active);
      const res = await REQUEST({
        method: 'POST',
        url: ALL_SUBMIT_FORM,
        data: { data: formData },
      });
      if (res?.status === 200) {
        reset();
        setActive(active);
        router.push('/thankyou');
      } else toast.error(res?.data?.error?.message);
    } catch (err) {
      toast.error('failed');
    }
  };

  return (
    <div>
      {isContect && (
        <>
          <form onSubmit={handleSubmit(Submit)} className="flex mt-10">
            <div>
              <input
                type="email"
                placeholder="Enter Email Id"
                className="text-[#434343] md:w-[300px] rounded-[4px_0px_0px_4px_!important] outline-0 md:text-[20px] text-[16px]
                            bg-[rgb(249_249_249)] border-[0.5px] border-[rgba(146,_146,_146,_0.5)] p-[8px_16px] h-[50px_!important]"
                name="email"
                {...register('email')}
                style={style.inputField}
                onChange={e => {
                  isValidEmail2(e.target.value);
                }}
              />
            </div>
            <button
              type="submit"
              disabled={active}
              className="px-6 pt-[0.5rem_!important] inline-flex  justify-center items-center rounded-[0px_4px_4px_0px_!important] bg-[#0050D5] text-white md:text-[20px] text-[16px] h-[50px] shadow-[10px_20px_40px_0px_#00000033]"
            >
              Subscribe
            </button>
          </form>
          {errors.email && (
            <span className="mt-2 font-[600] text-sm text-red-700 inline-block bg-[#fff] rounded-[4px] py-1 px-2">
              {errors.email?.message}
            </span>
          )}
          {!email2 && (
            <span className="mt-2 font-[600] text-sm text-red-700 inline-block bg-[#fff] rounded-[4px] py-1 px-2">
              {'Email must be a valid'}
            </span>
          )}
        </>
      )}
    </div>
  );
}
